// Mutual free/busy overlap between the signed-in user and one connected person.
import { apiFetch } from '../lib/api';
import { supabase } from '../lib/supabase';

// Calendar-sync horizon (api/services/syncService.js DEFAULT_DAYS_AHEAD). Beyond
// this we have no real synced availability — the UI shows an honest state rather
// than presenting unsynced gaps as free.
export const SYNC_HORIZON_DAYS = 60;

async function myUserId() {
  const { data } = await supabase.auth.getUser();
  return data.user?.id;
}

// Candidate-slot cadence, held fixed regardless of meeting length. Decoupled from
// duration deliberately: at slot_interval = durationMinutes a 2-hour meeting would
// only be offered at 2-hour starts; pinned at 30 a 90-min meeting is still offered
// at every half-hour. See when-spec-addendum-groups-durations.md, Section 1.
const SLOT_INTERVAL_MINUTES = 30;

/**
 * Mutual slots for [from, to). Returns { slots:[{start,end}], total_slots }.
 * duration defaults to 30 minutes; slot cadence is fixed at 30 (see above).
 */
export async function getOverlap(principalId, fromISO, toISO, { durationMinutes = 30 } = {}) {
  const me = await myUserId();
  const principals = [me, principalId].join(',');
  const params = new URLSearchParams({
    principal_ids: principals,
    from: fromISO,
    to: toISO,
    duration_minutes: String(durationMinutes),
    slot_interval: String(SLOT_INTERVAL_MINUTES),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    limit: '100',
  });
  return apiFetch(`/v1/availability/mutual?${params.toString()}`);
}
